export default __webpack_public_path__ + "6c2d9eea9f30067f7211eeda99828979.png";